<template>
  <div
    class="image"
    :class="wrapperClass"
    :style="styles"
  >
    <img
      :src="imageSrc"
      :data-src="src"
      data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
      :data-aspectratio="aspectRatio"
      data-sizes="auto"
      :alt="altText"
      :class="imageClasses"
    >
  </div>
</template>

<script>
export default {
  props: {
    altText: String,
    aspectRatio: Number,
    disableAspectRatio: {
      type: Boolean,
      default: false,
    },
    enableLazyload: {
      type: Boolean,
      default: true,
    },
    height: Number,
    placeholderSrc: String,
    src: {
      type: String,
      required: true,
    },
    width: Number,
    wrapperClass: String,
  },

  computed: {
    imageClasses() {
      return {
        'image__img': true,
        'lazyload': this.enableLazyload,
      };
    },

    imageSrc() {
      return this.enableLazyload ? this.placeholderSrc : this.src;
    },

    styles() {
      if (this.disableAspectRatio) {
        return null;
      }

      return {
        'padding-top': `${(this.height / this.width) * 100}%`,
        'position': 'absolute',
        'width': '100%'
      };
    },
  },
}
</script>

<style>

</style>